import defineTypes from './defineTypes';

export default (defaultState = {}, name) => {
  const types = defineTypes(['REPLACE', 'RESET', 'SET'], name);

  const reducer = (state = defaultState, action) => {
    const { type, payload } = action;

    switch (type) {
      case types.SET: {
        return {
          ...state,
          ...payload,
        };
      }

      case types.REPLACE: {
        return payload;
      }

      case types.RESET:
        return defaultState;

      default:
        return state;
    }
  };

  reducer.set = (payload) => ({
    type: types.SET,
    payload,
  });

  reducer.replace = (payload) => ({
    type: types.REPLACE,
    payload,
  });

  reducer.reset = () => ({
    type: types.RESET,
  });

  return reducer;
};
